import { render, staticRenderFns } from "./create-aisle.vue?vue&type=template&id=cd84b188&"
import script from "./create-aisle.vue?vue&type=script&lang=ts&"
export * from "./create-aisle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports